import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { CustodyAccountState } from "@modules/+new/custody_account/domain/entities/custody_account.model";
import { CustodyAccountVerifiedEligibility } from "@modules/+new/custody_account/domain/entities/custody_account_eligibility.model";
import { CustodyAccountOpeningStep } from "@modules/+new/custody_account/features/cam-modal/cam-modal.model";
import { Observable } from "rxjs";

const initialState: CustodyAccountState = {
	currentStep: CustodyAccountOpeningStep.PRESCREEN,
	isEligible: false,
	isVerificationLoading: false,
	isEligibilityLoaded: false,
	verifiedEligibility: CustodyAccountVerifiedEligibility.UNKNOWN
};

@Injectable({
	providedIn: "root"
})
export class CustodyAccountStateService extends StateService<CustodyAccountState> {
	constructor() {
		super(initialState);
	}

	public getUserEligibility$(): Observable<boolean> {
		return this.select((state) => state?.isEligible);
	}

	public setUserEligibility(eligibility: boolean): void {
		this.setState({
			isEligible: eligibility
		});
	}

	public setIsEligibilityLoaded(isEligibilityLoaded: boolean): void {
		this.setState({ isEligibilityLoaded });
	}

	public isEligibilityLoaded(): boolean {
		return this.state?.isEligibilityLoaded;
	}

	public setCAVerificationLoading(isVerificationLoading: boolean): void {
		this.setState({
			isVerificationLoading
		});
	}

	public isUserCAVerificationStatusLoading$(): Observable<boolean> {
		return this.select((state) => state?.isVerificationLoading);
	}

	public setUserVerifiedEligibility(verifiedEligibility: CustodyAccountVerifiedEligibility): void {
		this.setState({
			verifiedEligibility
		});
	}

	public getUserVerifiedEligibility$(): Observable<CustodyAccountVerifiedEligibility> {
		return this.select((state) => state?.verifiedEligibility);
	}
}
